import { useState, useEffect } from 'react';
import { useKeycloak } from '../../authentication/keycloak/KeycloakProvider';
import OfficeNotification from '../models/office-notification';
import { getAllOfficeNotificationsByOfficeId } from '../services/office-notification.services';

interface InitialNotificationState {
  readonly initialized: boolean;
  readonly error?: boolean;
  readonly errorNumber?: number;
}

interface NotificationsState extends InitialNotificationState {
  readonly officeNotifications?: OfficeNotification[];
}

interface Props {
  readonly id: string | undefined;
}

const useOfficeNotifications = ({ id }: Props): NotificationsState => {
  const [state, setState] = useState<NotificationsState>({
    initialized: false,
  });
  const keycloak = useKeycloak();

  useEffect(() => {
    const getNotifications = async (): Promise<void> => {
      try {
        if (!id || id === '') {
          return;
        }

        const officeNotifications = await getAllOfficeNotificationsByOfficeId(id, keycloak);

        if (typeof officeNotifications === 'number') {
          setState({
            initialized: true,
            error: true,
            errorNumber: officeNotifications,
            officeNotifications: [],
          });
        } else {
          setState({ initialized: true, officeNotifications });
        }
      } catch (error) {
        setState({ initialized: false, error: true });
      }
    };

    if (!state.initialized) {
      getNotifications();
    }
  }, [setState, state.initialized, keycloak, id]);

  return state;
};

export default useOfficeNotifications;
